import { camelize, snakeize } from 'casing'
import { API } from '../../../common/api'
import { labravAWSEngineServiceUrl } from '../../../common/utils/constants'
import {
  CollectionMetric,
  CollectionMetrics,
  CollectionType,
} from '../../modules/teamRelationship/types'

// Keep team-collections on the same aws_engine host as PartnerIQ
// (`labravAWSEngineServiceUrl`), including any VITE_AWS_ENGINE_SERVICE_URL override.
export const teamRelationshipAwsEngineUrl = labravAWSEngineServiceUrl

export type CreateTeamCollectionPayload = {
  name: string
  type: CollectionType
  memberIds: string[]
  createdBy: string
}

export type UpdateTeamCollectionPayload = {
  name?: string
  type?: CollectionType
  memberIds?: string[]
  isArchived?: boolean
}

export type TeamCollectionApiMember = {
  memberId: string
  memberName: string
  title?: string
  location?: string | null
  profileImageUrl?: string
  engagedWith?: Array<string | { name?: string; email?: string }> | null
  metrics?: {
    closedWon?: CollectionMetric
    inProgress?: CollectionMetric
  }
}

export type TeamCollectionApi = {
  id: string
  name: string
  type: CollectionType
  memberIds?: string[]
  createdAt?: string
  createdBy?: string
  metrics?: CollectionMetrics
  isArchived?: boolean
  members?: TeamCollectionApiMember[]
}

export type TeamCollectionsListResponse = {
  collections: TeamCollectionApi[]
}

export type FetchTeamCollectionsParams = {
  skip?: number
  limit?: number
}

export const createPartnerTeamCollection = (
  partnerId: string,
  payload: CreateTeamCollectionPayload
) =>
  API.post(
    `${teamRelationshipAwsEngineUrl}/partners/${partnerId}/team-collections`,
    snakeize(payload)
  )

export const fetchPartnerTeamCollections = (
  partnerId: string,
  params: FetchTeamCollectionsParams = {}
) =>
  API.get(
    `${teamRelationshipAwsEngineUrl}/partners/${partnerId}/team-collections`,
    {
      params: snakeize(params),
    }
  ).then(response => ({
    ...response,
    data: camelize(response.data ?? {}) as TeamCollectionsListResponse,
  }))

export const fetchPartnerTeamCollection = (
  partnerId: string,
  collectionId: string
) =>
  API.get(
    `${teamRelationshipAwsEngineUrl}/partners/${partnerId}/team-collections/${collectionId}`
  ).then(response => ({
    ...response,
    data: camelize(response.data ?? {}) as TeamCollectionApi,
  }))

export const updatePartnerTeamCollection = (
  partnerId: string,
  collectionId: string,
  payload: UpdateTeamCollectionPayload
) =>
  API.put(
    `${teamRelationshipAwsEngineUrl}/partners/${partnerId}/team-collections/${collectionId}`,
    snakeize(payload)
  ).then(response => ({
    ...response,
    data: camelize(response.data ?? {}) as TeamCollectionApi,
  }))
